/**
 * Notification API client
 */

import apiClient from '@/core/api/client'
import type {
  Notification,
  NotificationsResponse,
  UnreadCountResponse,
} from '../types/notification.types'

export const notificationApi = {
  /**
   * Get notifications for the current user
   */
  getNotifications: async (params?: {
    unread_only?: boolean
    limit?: number
  }): Promise<NotificationsResponse> => {
    const response = await apiClient.get('/v1/notifications', { params })
    return response.data
  },

  /**
   * Get unread count
   */
  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    const response = await apiClient.get('/v1/notifications/unread-count')
    return response.data
  },

  /**
   * Mark a notification as read
   */
  markAsRead: async (notificationId: string): Promise<{ data: Notification }> => {
    const response = await apiClient.post(`/v1/notifications/${notificationId}/read`)
    return response.data
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead: async (): Promise<{ count: number }> => {
    const response = await apiClient.post('/v1/notifications/mark-all-read')
    return response.data
  },
}
